<button type="{{type}}" [class]="kind" aria-label="ariaLabel" [class.focused]="isfocused"  [class.disabled]="isDisabled" (click)="click($event)" >
    <div class="app-btn__content" >

      <span class="app-button_text" *ngIf="label">{{label}}</span>
      <i *ngIf="icon"  [class]="icon"></i>
      <ng-content></ng-content>
    </div>
  </button>
